import React from 'react';

const SvgTriangle = ({ cx, cy, color, mouseEnter, mouseLeave, index }) => (
  <svg
    cx={cx}
    cy={cy}
    x={cx - 6}
    y={cy - 6}
    fill={color}
    onMouseEnter={() => mouseEnter(cx, cy, index)}
    onMouseLeave={() => mouseLeave()}
  >
    <path fill={color} stroke={color} d="M5 0l5 8H0z" />
  </svg>
);

export default SvgTriangle;
